import React, { useState } from 'react';
import './FilterBar.css';

function FilterBar({ 
  contacts,
  filterSource, 
  filterTaskStatus, 
  filterDateRange,
  onSourceChange, 
  onTaskStatusChange, 
  onDateRangeChange,
  onClearAll,
  activeFilterCount
}) {
  const [showPanel, setShowPanel] = useState(false);

  // Get unique sources from contacts
  const uniqueSources = [...new Set(contacts.map(c => c.source).filter(Boolean))];

  const handleToggle = () => {
    setShowPanel(!showPanel);
  };

  return (
    <div className="filter-bar">
      <button 
        className={`filter-toggle-btn ${showPanel ? 'active' : ''}`}
        onClick={handleToggle}
      >
        Filters {showPanel ? '▲' : '▼'}
        {activeFilterCount > 0 && (
          <span className="filter-badge">{activeFilterCount}</span>
        )}
      </button>

      {showPanel && (
        <div className="filter-panel">
          <div className="filter-grid">
            <div className="filter-group">
              <label>Source</label>
              <select 
                className="filter-dropdown"
                value={filterSource}
                onChange={(e) => onSourceChange(e.target.value)}
              >
                <option value="all">All Sources</option>
                {uniqueSources.map(source => (
                  <option key={source} value={source}>{source}</option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label>Task Progress</label>
              <select 
                className="filter-dropdown"
                value={filterTaskStatus}
                onChange={(e) => onTaskStatusChange(e.target.value)}
              >
                <option value="all">All</option>
                <option value="completed">Completed</option>
                <option value="in_progress">In Progress</option>
                <option value="not_started">Not Started</option>
              </select>
            </div>

            <div className="filter-group">
              <label>Date Added</label>
              <select 
                className="filter-dropdown"
                value={filterDateRange}
                onChange={(e) => onDateRangeChange(e.target.value)}
              >
                <option value="all">All Time</option>
                <option value="7d">Last 7 Days</option>
                <option value="30d">Last 30 Days</option>
                <option value="90d">Last 90 Days</option>
              </select>
            </div>

            {activeFilterCount > 0 && (
              <div className="filter-group">
                <label>&nbsp;</label>
                <button className="clear-filters-btn" onClick={onClearAll}>
                  Clear All
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default React.memo(FilterBar);

